import { Project } from 'api/project';
import { SelectFilterOperationType } from '../filters/select';
import { SingleSelectFieldFilter } from '../filters/single-select';
import { FilterFunction } from '.';

export const currency = (filter: SingleSelectFieldFilter): FilterFunction => {
  const getCurrency = (record) =>
    record.projectFinancialsDetailModel as Project['projectFinancialsDetailModel'];

  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return (record) => getCurrency(record)?.currency?.currencyCode == null;
    case SelectFilterOperationType.IsNotEmpty:
      return (record) => getCurrency(record)?.currency?.currencyCode != null;
    case SelectFilterOperationType.IsOneOf:
      return (record) =>
        filter.value!.some(
          (x) =>
            (x as unknown as string) ===
            getCurrency(record)?.currency?.currencyCode,
        );
    case SelectFilterOperationType.IsNoneOf:
      return (record) =>
        filter.value!.every(
          (x) =>
            (x as unknown as string) !==
            getCurrency(record)?.currency?.currencyCode,
        );
    case SelectFilterOperationType.Is:
      return (record) =>
        getCurrency(record)?.currency?.currencyCode === filter.value;
    case SelectFilterOperationType.IsNot:
      return (record) =>
        getCurrency(record)?.currency?.currencyCode !== filter.value;
    default:
      return () => true;
  }
};
